import React from "react";
import { Check } from "lucide-react";

const AboutCraftsmanship = () => {
  const points = [
    "Hand-selected materials for every piece",
    "Multiple quality control checkpoints",
    "Traditional techniques meet modern technology",
    "Lifetime service and maintenance support"
  ];

  return (
    <section className="bg-white py-24 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center gap-20">
        {/* Left Image */}
        <div className="lg:w-1/2">
          <div className="rounded-2xl overflow-hidden shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-700">
            <img 
              src="/about/artisan_crafting.png" 
              alt="Master Craftsman at Work" 
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* Right Content */}
        <div className="lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-8 uppercase">
            Master Craftsmanship
          </h2>
          <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
            <p>
              Our jewelry is more than just precious metals and stones—it's the
              result of skilled hands and passionate hearts working in harmony.
            </p>
            <p>
              Each piece undergoes rigorous quality checks at every stage of creation,
              from initial design to final polish. Our artisans combine time-honored
              techniques with modern precision to create jewelry that stands the test of
              time.
            </p>
            <div className="pt-6 space-y-4">
              {points.map((point, index) => (
                <div key={index} className="flex items-center gap-4 group">
                  <div className="w-6 h-6 rounded-full bg-[#fdfaf5] border border-[#D4AF37] flex items-center justify-center group-hover:bg-[#D4AF37] transition-colors">
                    <Check size={14} className="text-[#D4AF37] group-hover:text-white" />
                  </div>
                  <span className="text-gray-800 font-medium">{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCraftsmanship;
